import Axios from 'axios'
import AxiosBuilder from '@/services/axios-builder'
import Logger from '@/logger'

/**
 * Load API URL from current site.
 */
export default {
    load: async() => {
        const axios = Axios.create()
        const response = await axios.get('/api/grub')

        Logger.log(`Loaded domain from /api/grub: ${ response.data }`, 'GRUB')

        AxiosBuilder.setDomain(response.data)
    },
}
